

















































import { Component, namespace, mixins, Prop } from 'nuxt-property-decorator'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { ORDER_MAKE_API } from '~/assets/config/api-path'
import { PRIVACY_POLICY_PATH } from '~/assets/config/path'
import { filterUrl } from '~/assets/filters/url'
import MixinGeneral from '~/assets/mixins/general'
import { IUser } from '~/assets/interfaces/user'
import { analyticsReachGoal } from '~/assets/functions/analytics'
import { IProductAdditionalService } from '~/assets/interfaces/products'
import ComponentAlert from '~/components/alerts/alert.vue'
import ComponentFormButton from '~/components/form/button.vue'
import ComponentFormInputText from '~/components/form/input-text.vue'

const siteStore = namespace('site')
const cartStore = namespace('cart')
const authStore = namespace('auth')
@Component({
  layout: (ctx) => (ctx.$device.isMobileOrTablet ? 'mobile' : 'default'),
  filters: {
    filterUrl,
  },
  components: {
    ComponentAlert,
    ComponentFormInputText,
    ComponentFormButton,
  },
  mixins: [validationMixin],
  validations: {
    feedbackDataPhone: {
      required,
      correct: (val) => !val.includes('_'),
    },
    feedbackDataName: {
      required,
    },
  },
})
export default class ComponentOrderBuyOneClick extends mixins(MixinGeneral) {
  @Prop({ type: String }) readonly productId!: number | string
  @Prop({ type: Array, default: () => [] })
  readonly servicesForBuy!: IProductAdditionalService[]

  @siteStore.Getter('getOptionsPhoneMask') private getOptionsPhoneMask!: string
  @cartStore.Action('getItems') private getCartItems!: () => Promise<void>
  @authStore.State('user') private user!: IUser | null

  private PRIVACY_POLICY_PATH = PRIVACY_POLICY_PATH

  private feedbackDataName = ''
  private feedbackDataPhone = ''

  private get feedbackData() {
    const tempServicesForBuy = this.servicesForBuy
      .filter((item) => item.active)
      .map((item) => {
        return {
          id: item.id,
        }
      })

    return {
      name: this.feedbackDataName,
      phone: this.feedbackDataPhone,
      productId: this.productId,
      isOneClick: true,
      services: tempServicesForBuy,
    }
  }

  private isLoading = false
  private isSent = false
  private orderNum = ''
  private errorText = ''
  private async send() {
    this.isLoading = true
    this.errorText = ''
    this.$v.$touch()
    if (!this.$v.$invalid) {
      const response = await this.$axios.$post(
        ORDER_MAKE_API,
        this.feedbackData
      )
      if (response.success) {
        this.isSent = true
        this.orderNum = response.orderNum || ''

        if (this.productId) {
          analyticsReachGoal('goal_1click_success')
        } else {
          analyticsReachGoal('goal_fastorder_success')
        }
        await this.getCartItems()
      } else {
        this.errorText = response.text || 'Order request failed.'
      }
    }
    this.isLoading = false
  }

  private created() {
    if (this.user) {
      if (this.user.name) {
        this.feedbackDataName = this.user.name
      }
      if (this.user.phone) {
        this.feedbackDataPhone = this.user.phone
      }
    }
  }

  private mounted() {
    if (this.productId) {
      analyticsReachGoal('goal_1click_begin')
    } else {
      analyticsReachGoal('goal_fastorder_begin')
    }
  }
}
